<template>
  <div v-if="showBanner" class="flex items-center justify-center bg-[#390261] text-white">
    <span class="flex flex-1 items-center justify-center">
      <a v-if="courseIsOnSale" class="p-2 font-medium" href="https://dnsfordevelopers.com/"><span class="m-5">🎁</span>I'm turning 35! Get 35% off my DNS for Developers course.<span class="m-5">🎁</span></a>
      <a v-else class="p-2 font-medium" href="https://dnsfordevelopers.com/">DNS for Developers (video course) ✨ Black Friday Sale ✨</a>
    </span>
    <span class="justify-self-end p-2 cursor-pointer" @click="toggleBanner">
      <XMarkIcon class="h-5 w-5" />
    </span>
  </div>
  <div class="flex flex-col justify-between items-center shadow-sm bg-white text-gray-800 border-b border-gray-200 sm:flex-row sm:gap-3">
    <router-link to="/" class="mx-auto mt-4 min-w-fit pl-6 sm:m-0 sm:w-80"><img src="../../../public/img/logo.svg" alt="NsLookup logo" width="142" height="24" class="inline" /></router-link>
    <form class="w-full max-w-lg px-3 sm:pl-0 pd:pr-0" autocomplete="off">
      <DomainSearch :prefill="domain" @submitted="redirectTo" :button-text="searchButtonText" :autocomplete-enabled="autocompleteEnabled" />
    </form>
    <nav class="w-80 min-w-fit pr-2 whitespace-nowrap text-right hidden md:inline">
      <router-link to="/learning/" class="p-3 text-dark">Learning</router-link>
      <router-link to="/install/" class="p-3 text-dark hidden lg:inline">Browser extension</router-link>
      <a href="https://www.whoisfreaks.com/" rel="noopener" class="p-3 text-dark">
        <span class="hidden xl:inline">DNS lookup</span> API
      </a>
    </nav>
  </div>
</template>

<script setup lang="ts">
import { useStore } from 'vuex';
import { PropType, computed } from 'vue';
import { useRouter } from 'vue-router';
import DomainSearch from '@/components/DomainSearch.vue';
import { domainNameToUrlPath } from '@/common/domainName';
import { XMarkIcon } from '@heroicons/vue/24/outline';

const props = defineProps({
  domain: {
    type: String,
    default: undefined,
  },
  domainSearchToUrl: {
    type: Function as PropType<(encodedDomain: string) => string>,
    default: undefined,
  },
  searchButtonText: {
    type: String,
    default: undefined,
  },
  autocompleteEnabled: {
    type: Boolean,
    default: true,
  },
});

const courseIsOnSale = computed(
  () => new Date(new Date(2025, 6, 11).toDateString()) > new Date(new Date().toDateString()),
);

const router = useRouter();

const store = useStore();
const toggleBanner = () => store.commit('toggleBanner');
const showBanner = computed(() => store.state.showBanner);

function redirectTo(newDomain: string): void {
  if (props.domainSearchToUrl) {
    router.push(props.domainSearchToUrl(newDomain));
  } else {
    // Vue acts up when setting this as a default prop
    router.push(`/domains/${domainNameToUrlPath(newDomain)}/dns-records/`);
  }
}
</script>
